import { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
//import surveyJson from '../models/mtbaldy2';
import testData from '../assets/testform';
//import theme from '../themes/mtbaldy';
//import { uploadFileToAzureBlobStorage } from '../services/blobStorage';
import { uploadImage } from '../services/blobStorage';
//import { uploadFileToAzureFileService } from '../services/fileStorage';
import LoadingSpinner from './spinner';

const SLOPESYNC_REDIRECT_CONFIG = {
  enabled: true,
  oldHost: 'forms.getcontext.ca',
  targetOrigin: 'https://forms.slopesync.ca',
  targetTenantSlug: 'baldy',
  forceQueryParam: 'redirectToSlopesync'
};

const configureDynamicPanel = (survey, count) => {
  const panel = survey.getQuestionByName('members');
  if (panel) {
    panel.maxPanelCount = count;
    panel.allowAddPanel = true;
    panel.allowRemovePanel = true;
    panel.panelCount = Math.min(panel.panelCount || 1, count);
    console.log(`Dynamic panel configured with max count: ${count}`);
  } else {
    console.warn("Dynamic panel 'members' not found.");
  }
};

const MySurvey = () => {
  const navigate = useNavigate();
  const { schemaId, tenantSlug } = useParams();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const passGroup = queryParams.get('passGroup') || undefined;
  const groupId = queryParams.get('groupId') || undefined;
  const orderId = queryParams.get('orderId') || undefined;
  const dev = queryParams.get('dev') || "0";

  const [formName, setFormName] = useState('');
  const [survey] = useState(new Model());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [passJson, setPassJson] = useState({});

  //const containerSasUrl = import.meta.env.VITE_GC_SA_SAS_TOKEN;

  const apiBase = tenantSlug
  ? `${import.meta.env.VITE_API_URL}/api/public/${tenantSlug}`
  : `${import.meta.env.VITE_API_URL}/api`;

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!SLOPESYNC_REDIRECT_CONFIG.enabled) return;
    if (!schemaId) return;

    const currentHost = window.location.hostname;
    const shouldForceRedirect = queryParams.get(SLOPESYNC_REDIRECT_CONFIG.forceQueryParam) === '1';
    const shouldRedirect = shouldForceRedirect || currentHost === SLOPESYNC_REDIRECT_CONFIG.oldHost;

    if (!shouldRedirect) return;

    const nextParams = new URLSearchParams(search);
    nextParams.delete(SLOPESYNC_REDIRECT_CONFIG.forceQueryParam);

    const nextUrl = `${SLOPESYNC_REDIRECT_CONFIG.targetOrigin}/forms/${encodeURIComponent(
      SLOPESYNC_REDIRECT_CONFIG.targetTenantSlug
    )}/${encodeURIComponent(schemaId)}${nextParams.toString() ? `?${nextParams.toString()}` : ''}`;

    window.location.replace(nextUrl);
  }, [schemaId, search, queryParams]);

  useEffect(() => {
    if (!schemaId) {
      console.error("Missing schemaId in URL");
      alert("SchemaId is required");
      return;
    }

    const fetchData = async () => {
      try {
        // --- Fetch schema
        const schemaRes = await fetch(`${apiBase}/forms/schema/${schemaId}`);
        const schemaJson = await schemaRes.json();
        survey.fromJSON(schemaJson.content);
        if (schemaJson.name) setFormName(schemaJson.name);

        // --- Dev mode
        if (dev === "1") {
          survey.data = testData;
          survey.getAllQuestions().forEach((q) => (q.isRequired = false));
        }

        survey.setValue("status", "New");

        // --- Set groupId in survey data
        if (groupId) {
          survey.setValue("groupId", groupId);
        }

        // --- Fetch pass data (if passGroup provided)
        if (passGroup) {
          const passRes = await fetch(`${apiBase}/waivers/${passGroup}`);
          //const passJson = await passRes.json();
          setPassJson(await passRes.json());
        }

        // --- Configure dynamic panel (only for certain forms)
        if (groupId === 'ff2526' || schemaId === '67cd3a538cdcef9a9b12e3cb') {
          const panel = survey.getQuestionByName('members');
            if (panel) {
              panel.panelCount = 1
              panel.maxPanelCount = 6
              panel.allowAddPanel = true;
              panel.allowRemovePanel = true;
              console.log(`Dynamic panel configured with max count: 6`);
            } else {
              console.warn("Dynamic panel 'members' not found.");
            }
        }
      } catch (err) {
        console.error("Error initializing form", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [schemaId, passGroup, groupId]);


  useEffect(() => {

  if (passJson.formId) {
      alert("This waiver has already been completed.");
      // navigate(`/forms/${schemaId}/${passJson.formId}`);
      navigate(`/forms/form/${passJson.formId}`);
      return;
    }

    if (passJson.adjustedMaxMembers) {
      survey.setValue("maxMembers", passJson.adjustedMaxMembers);
      const panel = survey.getQuestionByName('members');
      if (panel) {
        panel.panelCount = passJson.adjustedMaxMembers
        panel.maxPanelCount = passJson.adjustedMaxMembers;
        panel.allowAddPanel = true;
        panel.allowRemovePanel = true;
        if (passJson.adjustedMaxMembers > 1) {
          panel.description = `Your membership allows up to ${passJson.adjustedMaxMembers} participants. Please list each season pass holder below. The information will be used to print your pass(es). Use the "Next" button to include additional individuals.`
        }
        console.log(`Dynamic panel configured with max count: ${passJson.adjustedMaxMembers}`);

        panel.panels.forEach((p, idx) => {
        const passholderName = p.getQuestionByName("passholdername")
        if (passholderName) {
          passholderName.value = passJson.passholderNames[idx] || "";
        }

      })

      } else {
        console.warn("Dynamic panel 'members' not found.");
      }
    }

    if (passJson.passGroup) {
          survey.setValue("passGroup", passJson.passGroup);
        }

    const primaryPassholderEmail = survey.getQuestionByName("email");
    if (passJson.passholderEmail) {
      primaryPassholderEmail.value = passJson.passholderEmail;
    }
  
  const passName = survey.getQuestionByName("Content1");

  if (passName) {
    // cache the original HTML ONCE
    if (!passName._originalHtml) {
      passName._originalHtml = passName.html;
    }

    // build new dynamic header
    const headerHtml = `
      <div style="margin-bottom: 8px">
        <p>
          <b>Membership:</b> ${passJson.name.replace(/\$[\d,]+(\.\d{2})?/g, "")} (${passJson.variationName.replace(/\$[\d,]+(\.\d{2})?/g, "")})<br />
          <b>Customer Email:</b> ${passJson.passholderEmail}
        </p>
      </div>
    `;

    // always reset to "header + original", never stacking more
    passName.html = `${headerHtml}${passName._originalHtml}`;
  }



}, [survey, passJson]);

  // --- Handle form complete v1
  // useEffect(() => {
  //   const handleComplete = (sender) => {

  //     const payload = {
  //       formSchemaId: schemaId,
  //       formSchema: sender.jsonObj,
  //       formContent: sender.data,
  //       formName,
  //     };

  //     fetch(`${import.meta.env.VITE_API_URL}/api/forms`, {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify(payload),
  //     });
  //   };

  //   survey.onComplete.add(handleComplete);
  //   return () => survey.onComplete.remove(handleComplete);
  // }, [formName]);

//   // --- Handle form complete v2
// useEffect(() => {
//   const handleComplete = async (sender, options) => {
//   // Prevent the default completion behavior
//   options.allowComplete = false;
  
//   try {
//     console.log('=== STARTING FORM COMPLETION ===');
    
//     const formData = { ...sender.data };
//     console.log('Initial formData:', formData);
    
//     // Check if we have members data with file uploads
//     if (formData.members && Array.isArray(formData.members)) {
//       console.log('Processing members array with length:', formData.members.length);
      
//       for (let i = 0; i < formData.members.length; i++) {
//         const member = formData.members[i];
//         console.log(`Processing member ${i}:`, member);
        
//         // Check for passimage field
//         if (member.passimage && Array.isArray(member.passimage)) {
//           const fileInfo = member.passimage[0];
//           console.log(`Found passimage for member ${i}:`, fileInfo);
          
//           if (fileInfo.content && fileInfo.content.startsWith('blob:')) {
//             try {
//               // Get the file from the blob URL
//               const response = await fetch(fileInfo.content);
//               const blob = await response.blob();
//               const file = new File([blob], fileInfo.name, { type: fileInfo.type });
              
//               console.log(`About to upload file for member ${i}:`, file.name);
              
//               const uploadedUrl = await uploadFileToAzureBlobStorage(file, passGroup);
              
//               console.log(`Upload completed for member ${i}:`, uploadedUrl);
//               formData.members[i].passimage = uploadedUrl.split('?')[0];
//               console.log(`Updated formData.members[${i}].passimage to:`, formData.members[i].passimage);
              
//             } catch (uploadError) {
//               console.error('Upload failed:', uploadError);
//               throw uploadError;
//             }
//           }
//         }
//       }
//     }
    
//     console.log('Final formData before API call:', formData);
    
//     const payload = {
//       formSchemaId: schemaId,
//       formSchema: sender.jsonObj,
//       formContent: formData,
//       formName,
//     };

//     await fetch(`${import.meta.env.VITE_API_URL}/api/forms`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(payload),
//     });
    
//     console.log('Form submission completed successfully');
    
//     // Now allow completion to proceed
//     options.allowComplete = true;
    
//   } catch (err) {
//     console.error("Error submitting form", err);
//     // Still allow completion even on error
//     options.allowComplete = true;
//   }
// };

//     survey.onComplete.add(handleComplete);
//     return () => survey.onComplete.remove(handleComplete);
//   }, [formName]);

  // --- Handle form complete v3
useEffect(() => {
  let isProcessing = false; // Flag to prevent duplicate processing
  
  const handleCompleting = async (sender, options) => {
    // If already processing, allow completion (this is the second pass)
    if (isProcessing) {
      options.allowComplete = true;
      return;
    }
    
    // First pass - prevent completion and start processing
    options.allowComplete = false;
    isProcessing = true;
    
    // Create and show loading overlay
    const loadingOverlay = document.createElement('div');
    loadingOverlay.id = 'form-loading-overlay';
    loadingOverlay.innerHTML = `
      <div style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; 
                  background: rgba(0,0,0,0.7); z-index: 10000; display: flex; 
                  flex-direction: column; align-items: center; justify-content: center; 
                  color: white; font-family: Arial, sans-serif;">
        <div style="background: white; color: black; padding: 30px; border-radius: 8px; 
                    text-align: center; box-shadow: 0 4px 20px rgba(0,0,0,0.3);">
          <div style="margin-bottom: 20px;">
            <div style="border: 4px solid #f3f3f3; border-top: 4px solid #3498db; 
                        border-radius: 50%; width: 40px; height: 40px; 
                        animation: spin 1s linear infinite; margin: 0 auto;"></div>
          </div>
          <div style="font-size: 18px; font-weight: bold;">Processing your submission...</div>
          <div style="font-size: 14px; color: #666; margin-top: 10px;">
            Uploading files and saving your information
          </div>
        </div>
      </div>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `;
    document.body.appendChild(loadingOverlay);
    
    try {
      const formData = { ...sender.data };
      let uploadPromises = [];
      
      console.log('Initial formData:', formData);
    
    // Check if we have members data with file uploads
    if (formData.members && Array.isArray(formData.members)) {
      console.log('Processing members array with length:', formData.members.length);
      
      for (let i = 0; i < formData.members.length; i++) {
        const member = formData.members[i];
        console.log(`Processing member ${i}:`, member);
        
        // Check for passimage field
        if (member.passimage && Array.isArray(member.passimage)) {
          const fileInfo = member.passimage[0];
          console.log(`Found passimage for member ${i}:`, fileInfo);
          
          if (fileInfo.content && fileInfo.content.startsWith('blob:')) {
            try {
              // Get the file from the blob URL
              const response = await fetch(fileInfo.content);
              const blob = await response.blob();
              const file = new File([blob], fileInfo.name, { type: fileInfo.type });
              
              console.log(`About to upload file for member ${i}:`, file.name);
              //const uploadedUrl = await uploadFileToAzureBlobStorage(file, passGroup);
              const result = await uploadImage(file, passJson, passGroup);
              
              console.log(`Upload completed for member ${i}:`, result);
              formData.members[i].passimage = [{
                name: file.name,
                type: fileInfo.type,
                content: result.url
              }]
              console.log(`Updated formData.members[${i}].passimage to:`, formData.members[i].passimage[0].content);
              
            } catch (uploadError) {
              console.error('Upload failed:', uploadError);
              throw uploadError;
            }
          }
        }
      }
    }
    
    console.log('Final formData before API call:', formData);

    const payload = {
      formSchemaId: schemaId,
      formSchema: sender.jsonObj,
      formContent: formData,
      formName,
    };

    if (orderId) {
      payload.orderId = orderId;
    }
      
      // Submit to API
      const response = await fetch(`${apiBase}/forms`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      
      if (!response.ok) {
        throw new Error(`API request failed with status ${response.status}`);
      }
      
      console.log('Form submission completed successfully');
      
      // Remove loading overlay
      document.body.removeChild(loadingOverlay);
      
      // Trigger completion by simulating the complete event
      // const completeEvent = new CustomEvent('complete');
      // sender.onComplete.fire(sender, { isCompleteOnTrigger: false });
      sender.doComplete()
      
    } catch (err) {
      console.error("Error submitting form:", err);
      
      // Remove loading overlay
      const overlay = document.getElementById('form-loading-overlay');
      if (overlay) {
        document.body.removeChild(overlay);
      }
      
      // Reset processing flag
      isProcessing = false;
      
      alert('There was an error submitting your form. Please try again.');
    }
  };

  survey.onCompleting.add(handleCompleting);
  return () => survey.onCompleting.remove(handleCompleting);
}, [formName, passJson, passGroup]);

  // --- Handle file upload v1
  // useEffect(() => {
  //   survey.onUploadFiles.add(async (sender, options) => {
  //     const [file] = options.files;
      
  //     try {
  //       const uploadedUrl = await uploadFileToAzureBlobStorage(file, passGroup);
  //       options.callback(options.files.map(file => ({
  //         file,
  //         content: uploadedUrl.split('?')[0]
  //       })));
  //     } catch (err) {
  //       console.error("File upload error", err);
  //     }

      
  //     // try {
  //     //   const uploadedFileUrl = await uploadFileToAzureFileService(file, "2526", passGroup);
  //     //   options.callback(options.files.map(file => ({
  //     //     file,
  //     //     content: uploadedFileUrl
  //     //   })));
  //     // } catch (err) {
  //     //   console.error("File upload error", err);
  //     // }

  //   });
  //   return () => survey.onUploadFiles.clear();
  // }, []);

  // --- Handle file upload v2
useEffect(() => {
  survey.onUploadFiles.add(async (sender, options) => {
    const [file] = options.files;
    
    try {
      // Create object URL for immediate display
      const objectUrl = URL.createObjectURL(file);
      
      options.callback(options.files.map(file => ({
        file,
        content: objectUrl
      })));
    } catch (err) {
      console.error("File processing error", err);
    }
  });
  
  return () => survey.onUploadFiles.clear();
}, []);

  // --- Handle signature date binding
  useEffect(() => {
    survey.onValueChanged.add((sender, { name, value, question }) => {
      if (question?.classMetaData.name !== "signaturepad") return;
      if (name.includes("-sd")) {
        sender.setValue(`${name}-signed-on`, value ? new Date().toISOString().slice(0, 16) : null);
      }
    });
  }, []);

  // if (loading) return <div>Loading...</div>;
  if (loading) return <LoadingSpinner />;
  if (error) return <div>Error: {error}</div>;

  return <Survey model={survey} />;
};

export default MySurvey;
